import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { MapComponent } from "@shared/components/map/map.component";
import { LocalizedDatePipe } from "@shared/pipes/localized-date.pipe";
import { MinorUnitCurrencyPipe } from "@shared/pipes/minor-unit-currency.pipe";
import { PluralTranslatePipe } from "@shared/pipes/plural-translate.pipe";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { OrderStatusPipe, SRPaymentStatusColorPipe, SRPaymentStatusIconPipe, SRPaymentStatusPipe } from "../domain/pipes/order-status.pipe";
import { CheckoutPageComponent } from "./checkout-page/checkout-page.component";
import { OrderHistoryPageComponent } from "./order-history-page/order-history-page.component";
import { PaymentPageComponent } from "./payment-page/payment-page.component";
import { PaymentResultComponent } from "./payment-result/payment-result.component";
import { ShoppingCartPageComponent } from "./shopping-cart-page/shopping-cart-page.component";

const materialModules = [MatProgressSpinnerModule, MatPaginatorModule, MatIconModule];

@NgModule({
  declarations: [
    ShoppingCartPageComponent,
    CheckoutPageComponent,
    PaymentPageComponent,
    PaymentResultComponent,
    OrderHistoryPageComponent,
    OrderStatusPipe,
    SRPaymentStatusIconPipe,
    SRPaymentStatusColorPipe,
    SRPaymentStatusPipe,
  ],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    RouterModule,
    MapComponent,
    FormsModule,
    ReactiveFormsModule,
    LocalizedDatePipe,
    MinorUnitCurrencyPipe,
    PluralTranslatePipe,
    ...materialModules,
  ],
})
export class OrderModule {}
